import { css } from '@mui/material/styles';
import { Children } from 'react';
export const avatarComponentOverrides = {
    MuiAvatar: {
        defaultProps: {
            variant: 'circular'
        },
        styleOverrides: {
            root: () => css `
                height: 2.5rem;
                width: 2.5rem;
                font-size: 1.125rem;
                line-height: 1.75rem;
                font-weight: 600;
                background-color: #666666;
                & .MuiSvgIcon-root {
                    height: 1.5rem;
                    width: 1.5rem;
                }
                &[data-fuel-size='small'] {
                    height: 2rem;
                    width: 2rem;
                    font-size: 0.875rem;
                    line-height: 1.25rem;
                        & .MuiSvgIcon-root {
                            height: 1.25rem;
                            width: 1.25rem;
                        }
                }
                &[data-fuel-size='large'] {
                    height: 3.5rem;
                    width: 3.5rem;
                    font-size: 1.5rem;
                    line-height: 2rem;
                        & .MuiSvgIcon-root {
                            height: 2.25rem;
                            width: 2.25rem;
                        }
                }
                &[data-fuel-color='purple'] {
                    background-color: #7E22CE;
                }
                &[data-fuel-color='rose'] {
                    background-color: #BE123C;
                }
                &[data-fuel-color='yellow'] {
                    background-color: #A16207;
                }
                &[data-fuel-color='blue'] {
                    background-color: #1D4ED8;
                }
                &[data-fuel-color='emerald'] {
                    background-color: #047857;
                }
            `
        }
    },
    MuiAvatarGroup: {
        defaultProps: {
            variant: 'circular'
        },
        styleOverrides: {
            root: ({ theme, ownerState }) => ({
                justifyContent: 'flex-end',
                ...[...Array(ownerState.max ?? 0)].reduce((result, curr, index) => ({
                    ...result,
                    [`& > .MuiAvatar-root:nth-of-type(${index + 1})`]: {
                        zIndex: (ownerState.max ?? 0) - index
                    }
                }), {}),
                '& .MuiAvatarGroup-avatar': {
                    borderStyle: 'solid',
                    borderColor: theme.tokens.FuelColorWhite,
                    boxSizing: 'content-box',
                    position: 'relative'
                },
                '&[data-fuel-size=\'small\']': {
                    '& .MuiAvatarGroup-avatar': {
                        height: '2rem',
                        width: '2rem',
                        fontSize: '0.875rem',
                        lineHeight: '1.25rem',
                        borderWidth: '0.125rem',
                        '&:not(:last-of-type)': {
                            marginLeft: '-8px'
                        },
                        '& .MuiSvgIcon-root': {
                            height: '1.25rem',
                            width: '1.25rem'
                        }
                    }
                },
                '&[data-fuel-size=\'medium\']': {
                    '& .MuiAvatarGroup-avatar': {
                        borderWidth: '0.125rem',
                        '&:not(:last-of-type)': {
                            marginLeft: '-12px'
                        },
                        '& .MuiSvgIcon-root': {
                            height: '1.5rem',
                            width: '1.5rem'
                        }
                    }
                },
                '&[data-fuel-size=\'large\']': {
                    '& .MuiAvatarGroup-avatar': {
                        height: '3.5rem',
                        width: '3.5rem',
                        fontSize: '1.5rem',
                        lineHeight: '2rem',
                        borderWidth: '0.25rem',
                        '&:not(:last-of-type)': {
                            marginLeft: '-18px'
                        },
                        '& .MuiSvgIcon-root': {
                            height: '2.25rem',
                            width: '2.25rem'
                        }
                    }
                },
                // #TODO: add tokens for colros
                '& .MuiAvatarGroup-avatar:nth-last-of-type(5n+1)': {
                    backgroundColor: '#7E22CE'
                },
                '& .MuiAvatarGroup-avatar:nth-last-of-type(5n+2)': {
                    backgroundColor: '#BE123C'
                },
                '& .MuiAvatarGroup-avatar:nth-last-of-type(5n+3)': {
                    backgroundColor: '#A16207'
                },
                '& .MuiAvatarGroup-avatar:nth-last-of-type(5n+4)': {
                    backgroundColor: '#1D4ED8'
                },
                '& .MuiAvatarGroup-avatar:nth-last-of-type(5n+5)': {
                    backgroundColor: '#047857'
                },
                ...(ownerState.max ?? 0) < Children.count(ownerState.children) && {
                    '& .MuiAvatarGroup-avatar:first-of-type': {
                        backgroundColor: theme.tokens.FuelColorGray700
                    }
                }
            })
        }
    }
};
